import { useState } from "react";
import { PIN_MAXIMO, type AutorizacaoAdmin } from "@caixaflow/shared";
import { useSessao } from "../api/sessao";
import { Campo } from "./Campos";

/**
 * Autorização de ADMIN digitada no aparelho do operador: o PIN de um ADMIN (padrão) ou o
 * e-mail e a senha dele. Quando quem está logado já é ADMIN, a sessão autoriza e os campos
 * nem aparecem (\`precisa\` fica falso).
 */
export function useAutorizacaoAdmin() {
  const { data: sessao } = useSessao();
  const [modo, setModo] = useState<"PIN" | "SENHA">("PIN");
  const [pin, setPin] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [adminSenha, setAdminSenha] = useState("");
  const precisa = sessao?.usuario.perfil !== "ADMIN";

  const valor: AutorizacaoAdmin | undefined = !precisa
    ? undefined
    : modo === "PIN"
      ? { tipo: "PIN", pin }
      : { tipo: "SENHA", adminEmail, adminSenha };

  return {
    precisa,
    modo,
    alternar: () => setModo((m) => (m === "PIN" ? "SENHA" : "PIN")),
    pin,
    setPin,
    adminEmail,
    setAdminEmail,
    adminSenha,
    setAdminSenha,
    valor,
    /** Depois de um erro, o segredo digitado é apagado (o e-mail fica). */
    limparSegredo: () => {
      setPin("");
      setAdminSenha("");
    },
  };
}

export function CamposAutorizacao({ autorizacao: a, erro }: { autorizacao: ReturnType<typeof useAutorizacaoAdmin>; erro?: (campo: string) => string | undefined }) {
  if (!a.precisa) return null;
  return (
    <div className="form" style={{ gap: 10 }}>
      {a.modo === "PIN" ? (
        <Campo rotulo="PIN do ADMIN" dica="um administrador digita aqui" erro={erro?.("autorizacao.pin")}>
          <input
            type="password"
            inputMode="numeric"
            pattern="[0-9]*"
            autoComplete="off"
            required
            maxLength={PIN_MAXIMO}
            value={a.pin}
            onChange={(e) => a.setPin(e.target.value.replace(/\D/g, "").slice(0, PIN_MAXIMO))}
            className="campo-pin"
          />
        </Campo>
      ) : (
        <>
          <Campo rotulo="E-mail do ADMIN" erro={erro?.("autorizacao.adminEmail")}>
            <input
              type="email"
              required
              inputMode="email"
              autoComplete="off"
              value={a.adminEmail}
              onChange={(e) => a.setAdminEmail(e.target.value)}
            />
          </Campo>
          <Campo rotulo="Senha do ADMIN" erro={erro?.("autorizacao.adminSenha")}>
            <input type="password" required autoComplete="new-password" value={a.adminSenha} onChange={(e) => a.setAdminSenha(e.target.value)} />
          </Campo>
        </>
      )}
      <button type="button" className="link-botao" style={{ alignSelf: "flex-start", padding: 0 }} onClick={a.alternar}>
        {a.modo === "PIN" ? "Usar e-mail e senha do ADMIN" : "Usar o PIN do ADMIN"}
      </button>
    </div>
  );
}
